import { Model, View } from '@lernetz/ts-lib';

import template from './DebugMessage.html';

export class DebugMessage extends Model {

    public constructor( public readonly message: string ) {
        super();
    }
}

export class DebugMessageView extends View<DebugMessage> {

    public constructor() {
        super( { template } );
    }
}
